import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center mt-10 mt-lg-0" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_8 = {
    key: 1,
    class: "row g-4"
};
const _hoisted_9 = { class: "gallery-item position-relative group" };
const _hoisted_10 = { class: "ratio ratio-1x1 overflow-hidden bg-light rounded-1 border" };
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = { class: "item-overlay position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-between p-2 opacity-0 transition" };
const _hoisted_13 = { class: "badge bg-dark align-self-start small" };
const _hoisted_14 = { class: "text-end" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
    key: 2,
    class: "text-center py-5 text-muted"
};
const _hoisted_17 = {
    class: "modal fade",
    id: "galleryUploadModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_18 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_19 = { class: "modal-content border-0 rounded-1" };
const _hoisted_20 = { class: "modal-body p-20" };
const _hoisted_21 = { class: "mb-3" };
const _hoisted_22 = ["value"];
const _hoisted_23 = {
    key: 0,
    class: "selected-files-preview overflow-auto",
    style: { "max-height": "200px" }
};
const _hoisted_24 = {
    class: "text-truncate",
    style: { "max-width": "200px" }
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = { class: "text-end mt-4" };
const _hoisted_27 = ["disabled"];
const _hoisted_28 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "card-title fw-bold mb-0 me-20" }, "Galerie Photos", -1)),
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openUploadModal && _ctx.openUploadModal(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block",
                    type: "button"
                }, [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Ajouter des photos ", -1),
                        _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                    ]))])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-select shadow-none rounded-0 me-15",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.filterCategory) = $event))
                }, [
                    _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Toutes les catégories", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: cat,
                            value: cat
                        }, _toDisplayString(cat), 9, _hoisted_5));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.filterCategory]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_ctx.filteredGallery.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredGallery, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: item.id,
                                class: "col-6 col-sm-4 col-md-3 col-xl-2"
                            }, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("img", {
                                            src: item.imageUrl,
                                            class: "object-fit-cover transition",
                                            alt: item.category
                                        }, null, 8, _hoisted_11)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.category), 1),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (_ctx.confirmDelete(item)),
                                                class: "btn btn-danger btn-sm rounded-circle shadow"
                                            }, [...(_cache[12] || (_cache[12] = [
                                                    _createElementVNode("i", { class: "flaticon-delete fs-12" }, null, -1)
                                                ]))], 8, _hoisted_15)
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128))
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "flaticon-gallery-1 fs-1 display-1 d-block mb-3 opacity-25" }, null, -1),
                            _createTextVNode(" Aucune image dans la galerie. ", -1)
                        ]))]))
        ]),
        _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", { class: "modal-title fw-bold" }, "Ajouter à la galerie"),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Catégorie", -1)),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select shadow-none rounded-0",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.uploadForm.category) = $event))
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: cat,
                                        value: cat
                                    }, _toDisplayString(cat), 9, _hoisted_22));
                                }), 128)),
                                _cache[14] || (_cache[14] = _createElementVNode("option", { value: "Autre" }, "Autre", -1))
                            ], 512), [
                                [_vModelSelect, _ctx.uploadForm.category]
                            ])
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(["upload-area border-dashed p-4 text-center bg-light transition mb-3", { 'border-primary': _ctx.isDragging }]),
                            onDragover: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.isDragging = true), ["prevent"])),
                            onDragleave: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.isDragging = false), ["prevent"])),
                            onDrop: _cache[7] || (_cache[7] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
                        }, [
                            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-gallery-1 fs-2 text-muted mb-2 d-block" }, null, -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mb-2 small" }, "Glissez vos images ici ou", -1)),
                            _createElementVNode("button", {
                                class: "btn btn-outline-primary btn-sm rounded-0",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$refs.fileInput.click()))
                            }, " Parcourir les fichiers "),
                            _createElementVNode("input", {
                                type: "file",
                                ref: "fileInput",
                                class: "d-none",
                                multiple: "",
                                accept: "image/*",
                                onChange: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
                            }, null, 544)
                        ], 34),
                        (_ctx.selectedFiles.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFiles, (file, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "d-flex align-items-center justify-content-between p-2 border-bottom small"
                                    }, [
                                        _createElementVNode("span", _hoisted_24, _toDisplayString(file.name), 1),
                                        _createElementVNode("button", {
                                            onClick: ($event) => (_ctx.removeFile(index)),
                                            class: "btn btn-link text-danger p-0"
                                        }, [...(_cache[18] || (_cache[18] = [
                                                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                            ]))], 8, _hoisted_25)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_26, [
                            _cache[19] || (_cache[19] = _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary me-2 rounded-0",
                                "data-bs-dismiss": "modal"
                            }, "Annuler", -1)),
                            _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.startUpload && _ctx.startUpload(...args))),
                                class: "btn btn-primary rounded-0 px-4",
                                disabled: _ctx.isUploading || _ctx.selectedFiles.length === 0
                            }, [
                                (_ctx.isUploading)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_28))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.isUploading ? 'Téléchargement...' : 'Envoyer (' + _ctx.selectedFiles.length + ')'), 1)
                            ], 8, _hoisted_27)
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
